import { connect } from 'react-redux'
import { getSelectionByKey } from '../../selection/selectors'
import {
  getBudget,
  getBudgetOverview,
} from '../selectors'
import { setBudgetValue } from '../actions'
import Budget from '../components/budget'

const mapStateToProps = state => ({
  budget: getBudget(state),
  budgetOverview: getBudgetOverview(state),
  budgetSelection: getSelectionByKey({
    state,
    key: 'budget',
  }),
})

const mapDispatchToProps = dispatch => ({
  setBudget: (payload) => {
    dispatch(setBudgetValue(payload))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Budget)



// WEBPACK FOOTER //
// ./src/modules/budget/containers/budget.js